export default __webpack_public_path__ + "static/2-e877219147a5dcde22fc0d42085d1766.svg";